




















import { Component, Prop, mixins } from 'nuxt-property-decorator'
import {
  defineComponent,
  ref,
  computed,
  useStore,
  useContext,
} from '@nuxtjs/composition-api'
import { Logger } from '../composition/Logger'
import { SectionCore } from '@/mixins/sectionCore'
import { SectionNews as SectionNewsProps } from '@/contracts/Section'
import { news } from '@/apollo/queries/news'
import type { QueryElementsArgs } from '@/apollo/composition-functions'
import { newsAdapter } from '@/apollo/adapters/modules'
import SectionBasic from '@/components/SectionBasic.vue'
import BlockCardNewsList from '@/components/CardLists/BlockCardNewsList.vue'
import BlockBreadCrumbs from '@/components/BlockBreadCrumbs.vue'

@Component
class SectionAllNews extends mixins(SectionCore) implements SectionNewsProps {
  @Prop() readonly list = []
  @Prop() readonly count = 0
  @Prop() readonly sectionMainTitle: string = ''
  @Prop() readonly sectionDate: string = ''
}

export default defineComponent({
  name: 'SectionAllNews',
  components: {
    SectionBasic,
    BlockCardNewsList,
    BlockBreadCrumbs,
  },
  props: SectionAllNews.options.props,
  setup() {
    const context = useContext()
    const { getters } = useStore()

    const { news: preloadedNews, newsCount: preloadedNewsCount } =
      getters['pagesData/GET_AUXILIARY_DATA']

    const loadNews = ref(false)
    const loadError = ref(false)
    const listValues = ref(newsAdapter(preloadedNews))
    const totalCount = ref(preloadedNewsCount)
    const textButton = computed(() => getters['settings/btnLoadMore'])
    const filters: QueryElementsArgs = {
      orderBy: { activeFrom: 'desc' },
      first: 6,
    }
    const getManyNews = async (idElement?: string) => {
      loadNews.value = true
      if (idElement) {
        filters.after = {
          id: idElement,
        }
      }
      try {
        const {
          data: { news: loadedNews, newsCount: loadedNewsCount },
        } = await context.$api.requests.sendGraphqlQuery({
          query: news.loc?.source.body,
          variables: filters,
        })
        const newsData = newsAdapter(loadedNews)
        newsData.forEach((item: any) => {
          listValues.value.push(item)
        })
        totalCount.value = loadedNewsCount
        loadNews.value = false
      } catch (e) {
        Logger.error(e)
        loadNews.value = false
        loadError.value = true
      }
    }

    const getMore = (idElement: string) => {
      getManyNews(idElement)
    }
    return {
      loadError,
      loadNews,
      listValues,
      getMore,
      totalCount,
      textButton,
    }
  },
})
